import Button from "@/common/Button";
import InputText from "@/common/InputText";
import { GetNumberProps } from "@/types/authType";

function GetNumber({
  onSubmit,
  isLoading,
  handleSubmit,
  register,
  errors,
  isValid,
}: GetNumberProps) {
  return (
    // Step 1 Form Input
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <InputText
        formObject={register("mobileNumber", {
          required: "شماره موبایل اجباری است",
          validate: (value) => {
            if (!value) return true;
            if (!value.startsWith("09")) {
              return "لطفا شماره موبایل باید با 09 شروع شود";
            }
            if (value.length !== 11) {
              return "شماره موبایل باید 11 رقم باشد";
            }
            return true;
          },
        })}
        type="tel"
        inputMode="numeric"
        className="h-12 text-right text-base bg-gray-100 rounded-lg px-4"
        containerClass="mt-10"
        errors={errors?.mobileNumber}
        labelText={"شماره موبایل"}
        labelTextClass="text-gray-500 mt-4 text-sm"
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            handleSubmit(onSubmit)();
          } else if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
          }
        }}
      />
      <Button
        type="submit"
        variant="dark-gray"
        isValid={isValid}
        className="h-12 w-full text-sm mt-9 py-5  cursor-pointer rounded-xl"
        isLoading={isLoading}
        disabled={isLoading}
      >
        <span>{"ارسال کد"}</span>
      </Button>
    </form>
  );
}

export default GetNumber;
